import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cp-stock-pickup',
  templateUrl: './stock-pickup.component.html',
  styleUrls: ['./stock-pickup.component.scss']
})
export class StockPickupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
